import React, { useState } from 'react';
import { players } from '../mockData';
import { Button } from './ui/button';
import { Filter, ChevronLeft, ChevronRight } from 'lucide-react';

const PLAYERS_PER_PAGE = 12; // Mostrar 12 jugadores por página

const Players = () => {
  const [selectedPosition, setSelectedPosition] = useState('Todos');
  const [currentPage, setCurrentPage] = useState(1);

  const positions = ['Todos', 'Delantero', 'Centrocampista', 'Defensa', 'Portero'];

  const filteredPlayers = selectedPosition === 'Todos'
    ? players
    : players.filter(player => player.position === selectedPosition);

  // Calcular paginación
  const totalPages = Math.ceil(filteredPlayers.length / PLAYERS_PER_PAGE);
  const startIndex = (currentPage - 1) * PLAYERS_PER_PAGE;
  const endIndex = startIndex + PLAYERS_PER_PAGE;
  const currentPlayers = filteredPlayers.slice(startIndex, endIndex);

  // Resetear página cuando cambia el filtro
  const handlePositionChange = (position) => {
    setSelectedPosition(position);
    setCurrentPage(1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      // Scroll to top of players section
      document.getElementById('players')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      // Scroll to top of players section
      document.getElementById('players')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="players" className="section-standard">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">JUGADORES REPRESENTADOS</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle body-medium">
            Representamos a {players.length} futbolistas profesionales de máximo nivel en diferentes categorías.
          </p>
        </div>

        {/* Position Filter */}
        <div className="filter-container">
          <Filter size={20} className="filter-icon" />
          <span className="filter-label caption">FILTRAR POR POSICIÓN:</span>
          <div className="filter-buttons">
            {positions.map(position => (
              <Button
                key={position}
                onClick={() => handlePositionChange(position)}
                className={selectedPosition === position ? 'filter-btn-active' : 'filter-btn'}
              >
                {position}
              </Button>
            ))}
          </div>
        </div>

        {/* Results info */}
        <div className="players-results-info">
          <p className="body-small">
            Mostrando {startIndex + 1}-{Math.min(endIndex, filteredPlayers.length)} de {filteredPlayers.length} jugadores
          </p>
        </div>

        {/* Players Grid */}
        <div className="players-grid">
          {currentPlayers.map(player => (
            <div key={player.id} className="player-card">
              <div className="player-image-container">
                <img
                  src={player.image}
                  alt={player.name}
                  className="player-image"
                />
                <div className="player-overlay">
                  <span className="player-position caption">{player.position}</span>
                </div>
              </div>
              <div className="player-info">
                <h3 className="heading-5">{player.name}</h3>
                <div className="player-meta">
                  {player.age && <><span className="caption">{player.age} AÑOS</span>
                  <span className="caption-separator">•</span></>}
                  <span className="caption">{player.nationality}</span>
                </div>
                <p className="player-club body-small">{player.club}</p>
                {player.division && <p className="player-division caption">{player.division}</p>}
                <p className="player-career caption">{player.career}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="pagination-controls">
            <Button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className={currentPage === 1 ? 'pagination-btn-disabled' : 'pagination-btn'}
            >
              <ChevronLeft size={20} />
              Anterior
            </Button>

            <div className="pagination-info">
              <span className="caption">
                Página {currentPage} de {totalPages}
              </span>
            </div>

            <Button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className={currentPage === totalPages ? 'pagination-btn-disabled' : 'pagination-btn'}
            >
              Siguiente
              <ChevronRight size={20} />
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Players;